import { price as priceUtils } from '@eti/utils';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { vars } from '@etg/wings';
import { dataCellStyles } from '../utils/summaryStyles';
import SummaryPriceInformation from './SummaryPriceInformation';
import SummaryPriceInformationPerCarrier from './SummaryPriceInformationPerCarrier';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const cellStyles = css`
  ${dataCellStyles};

  @media (max-width: 47.9375em) {
    display: block;
    margin-left: 36px;
    max-width: 43%;

    html[dir='rtl'] & {
      margin-left: 0;
      margin-right: 36px;
    }
  }
`;
const priceStyles = css`
  display: flex;
`;
const labelStyle = css`
  color: ${vars.colors.inputs.border};
  margin-right: 3px;
`;
const SummaryPriceCell = _ref => {
  let {
    markup = null,
    seatPrice,
    markupTooltipId,
    carrier,
    isRyanairInTrip
  } = _ref;
  const {
    t
  } = useTranslation();
  const summarySeatSelectedPriceLabel = t('Product.SeatMap.Seat.Price');
  return /*#__PURE__*/_jsx("td", {
    className: cellStyles,
    children: typeof seatPrice === 'number' && /*#__PURE__*/_jsxs("div", {
      className: priceStyles,
      children: [/*#__PURE__*/_jsx("span", {
        className: labelStyle,
        children: summarySeatSelectedPriceLabel
      }), priceUtils.formatPrice(seatPrice), isRyanairInTrip ? /*#__PURE__*/_jsx(SummaryPriceInformationPerCarrier, {
        id: markupTooltipId,
        markup: markup || 0,
        price: seatPrice,
        segmentCarrierName: carrier === null || carrier === void 0 ? void 0 : carrier.name
      }) : typeof markup === 'number' && /*#__PURE__*/_jsx(SummaryPriceInformation, {
        id: markupTooltipId,
        markup: markup,
        price: seatPrice
      })]
    })
  });
};
export default SummaryPriceCell;
//# sourceMappingURL=SummaryPriceCell.js.map